
var dateUtil = require('../../dateUtil/dateUtil');
var storefrontUtility = require('../storefrontUtility');
const storefrontTimingsUtil = require('../storefront/storefrontTimingsUtil');

module.exports.calculateChannelDispatchTime = function(sale)
{
    const storefront = storefrontUtility.getStorefrontById(sale.storefrontId);

    const { prepTime, orderIntervals } = storefrontTimingsUtil.getSalePrepAndDeliveryTimings(sale, storefront.timingConfigurations);

    let channelDispatchTime = dateUtil.addMinutes(sale.dateTime, prepTime);
    
    channelDispatchTime = storefrontTimingsUtil.adjustForOrderInterval(channelDispatchTime, orderIntervals[0]);
    
    return channelDispatchTime;
}